<template>
  <div :class="{ 'd-none': hidden }">
    <FormFieldsRow
      v-for="(outcome, index) in learningOutcomes"
      :key="index"
      :index="index"
      :isEditing="editable"
      class="mb-4 px-2 py-3"
    >
      <FormLearningOutcome
        :value="outcome"
        :editable="editable"
        :config="config"
        :disabled="disabled"
        :iteration="iteration"
        :index="index"
        :formValue="formValue"
        :nestedMode="nestedMode"
        @delete="deleteItem(index)"
      />
    </FormFieldsRow>
    <div
      v-if="!learningOutcomes || !learningOutcomes.length"
      class="p-3 mb-2 text-muted bg-light rounded-5 text-center border"
    >No Learning Outcomes Added</div>
    <AppButton
      v-if="!disabled"
      @click.stop="addItem"
    >
      Add New Outcome
    </AppButton>
  </div>
</template>
<script>
import FormMixin from '@/components/Forms/FormMixin'
import FormFieldsRow from '@/components/Forms/FormFieldsRow'
import FormLearningOutcome from '@/components/Forms/FormLearningOutcome'
import useFormListWrapper from './composables/useFormListWrapper'

export default {
  mixins: [ FormMixin ],
  components: {
    FormFieldsRow,
    FormLearningOutcome,
  },
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
    iteration: {
      type: Number,
      default: 0,
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { root, emit }) {
    function createEmptyItem () {
      return {
        id: root.generateToken(5),
        tags: [],
      }
    }

    const {
      items,
      addItem,
      deleteItem,
    } = useFormListWrapper({ props, emit, createEmptyItem })

    return {
      learningOutcomes: items,
      addItem,
      deleteItem,
    }
  },
}
</script>
